import { Dialog } from "@headlessui/react";
import CustomDialog from "../basic/Dialog";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { Icon } from "@iconify/react";

function InstructionDialog({ show, close, redirectUrl, allowDontShow = true }) {
  const [dontShow, setDontShow] = useState(
    Cookies.get("dontShowInstruction") == "true" && !allowDontShow
  );
  //const [dontShow, setDontShow] = (true, true);

  const videoNode = useRef();
  const playerRef = useRef();

  const videoJsOptions = {
    controls: true,
    responsive: true,
    fluid: true,
    preload: "auto",
    poster: "https://ik.imagekit.io/getactyv/images/InstructionPoster.png",
    sources: [
      {
        src: "https://getactyvfitness.blob.core.windows.net/old-videos/GIFS-1-plotted.mp4",
        type: "video/mp4",
      },
    ],
  };
  useEffect(() => {
    if (show)
      setTimeout(() => {
        playerRef.current = videojs(
          videoNode.current,
          videoJsOptions,
          () => {}
        );
      }, 100);
    else {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    }
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [show]);
  return (
    <CustomDialog show={show} close={close}>
      <Dialog.Panel
        className={`relative w-full max-w-3xl bg-gradient-to-r from-[#2A2A35] to-[#494959F2] transform  rounded-2xl text-left align-middle shadow-xl transition-all`}
      >
        <div
          onClick={close}
          className="cursor-pointer bg-[#d9d9d9] rounded-full absolute -right-2 md:-right-5 -top-2 md:-top-5 w-10 h-10 justify-center items-center flex"
        >
          <Icon icon="carbon:close" className="h-6 w-6" />
        </div>
        <p className="text-white font-bold font-open-sans text-xl py-4 px-10 text-start ">
          Setup and start in less than 30 seconds
        </p>
        <video
          id="istructionVideo"
          ref={videoNode}
          autoPlay
          className=" video-js vjs-big-play-centered w-screen object-cover"
          onEnded={() => {
            videoNode.current.load();
          }}
        />
        <div className="flex flex-row">
          {allowDontShow && (
            <label className="flex flex-1 w-full text-primary-gray items-center px-4 gap-2">
              <input
                type="checkbox"
                checked={dontShow}
                className="outline-none"
                onChange={() => {
                  setDontShow(!dontShow);
                }}
              />
              Don't show again
            </label>
          )}
          <div
            className="flex flex-1 justify-end p-2"
            onClick={() => {
              if (dontShow) {
                Cookies.set("dontShowInstruction", "true");
              } else {
                Cookies.set("dontShowInstruction", "false");
              }
            }}
          >
            <a href={redirectUrl}>
              <div className="text-primary-black max-w-max self-end flex bg-primary-neonGreen p-3 rounded-xl font-open-sans cursor-pointer">
                Understood, continue
              </div>
            </a>
          </div>
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

export default InstructionDialog;
